<template>
  <section class="learners-testimonial section">
    <h2>{{ headline }}</h2>
    <div class="purple">
      <div class="container ">
        <div id="learners-testimonial" class="row slider-override-mobile">
          <div class="learner" v-for="item in items" :key="item.title">
            <div class="learner__content">
              <img
                :src="item.image"
                style="max-width:75px; max-height:75px; margin-top:0;"
              />

              <p class="learner__message">
                {{ item.body }}
              </p>
              <p class="learner__designation" style="margin-bottom: 35px;">
                {{ item.subtitle }}
              </p>
              <h4 class="learner__name">{{ item.title }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['headline', 'items'],
}
</script>
<style scoped>
.container {
  max-width: 1300px;
  margin: 0 auto;
}
.purple {
  background-color: #184dbd;
  margin-top: 50px;
}
.learner__message {
  font-family: 'Manrope';
  font-weight: 400;
}
.learner__name {
  font-family: 'Manrope';
  font-weight: 700;
}
</style>
